import { render } from "./LoadingAlert.vue?vue&type=template&id=90502cdc"
import script from "./LoadingAlert.vue?vue&type=script&lang=js"
export * from "./LoadingAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__